import React from 'react';
import { Cookie } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import LegalPageLayout from '../components/LegalPageLayout';

const CookiePolicy = ({ embedded = false }) => {
  const { lang } = useLanguage();
  const english = lang === 'en';

  return (
    <LegalPageLayout
      embedded={embedded}
      icon={Cookie}
      title={english ? 'Cookie Policy' : 'Cookiebeleid'}
      updated={english ? 'Last updated: February 2026' : 'Laatst bijgewerkt: februari 2026'}
      backLabel={english ? 'Back to Home' : 'Terug naar Home'}
      testId="cookies-back-btn"
    >
          {english ? <>
          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB', marginTop: 0 }}>1. What are cookies?</h2>
          <p>Cookies are small text files stored on your device by your web browser when you visit our website. They help us remember your preferences and improve your experience.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>2. Cookies we use</h2>
          <p>We use the following types of cookies:</p>
          <ul>
            <li><strong>Essential:</strong> Necessary for the website to function (authentication, language preference)</li>
            <li><strong>Functional:</strong> Remember your preferences and settings</li>
            <li><strong>Analytics:</strong> Help us understand how visitors use the website</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>3. Managing cookies</h2>
          <p>You can manage cookies through your web browser settings. Please note that disabling essential cookies may limit the functionality of our website.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>4. Third-party cookies</h2>
          <p>We may use third-party services that place cookies. We do not control these cookies. Please consult the relevant third party's privacy policy for more information.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>5. Contact</h2>
          <p>If you have questions about our Cookie Policy, contact us at:</p>
          <p style={{ fontWeight: 500 }}>Email: info@krypton9.com</p>
          </> : <>
          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB', marginTop: 0 }}>1. Wat zijn cookies?</h2>
          <p>Cookies zijn kleine tekstbestanden die door uw webbrowser op uw apparaat worden opgeslagen wanneer u onze website bezoekt. Ze helpen ons om uw voorkeuren te onthouden en uw ervaring te verbeteren.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>2. Welke cookies gebruiken wij</h2>
          <p>Wij gebruiken de volgende typen cookies:</p>
          <ul>
            <li><strong>Essentieel:</strong> Noodzakelijk voor het functioneren van de website (authenticatie, taalvoorkeur)</li>
            <li><strong>Functioneel:</strong> Onthouden uw voorkeuren en instellingen</li>
            <li><strong>Analytisch:</strong> Helpen ons begrijpen hoe bezoekers de website gebruiken</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>3. Cookies beheren</h2>
          <p>U kunt cookies beheren via de instellingen van uw webbrowser. Let op: het uitschakelen van essentiële cookies kan de functionaliteit van onze website beperken.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>4. Cookies van derden</h2>
          <p>Wij kunnen diensten van derden gebruiken die cookies plaatsen. Wij hebben geen controle over deze cookies. Raadpleeg het privacybeleid van de betreffende derde partij voor meer informatie.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>5. Contact</h2>
          <p>Voor vragen over ons cookiebeleid kunt u contact opnemen via:</p>
          <p style={{ fontWeight: 500 }}>E-mail: info@krypton9.com</p>
          </>}
    </LegalPageLayout>
  );
};

export default CookiePolicy;
